import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=67e8b9f7&scoped=true&crossorigin=use-credentials"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=67e8b9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8b9f7",
  null
  
)

export default component.exports